var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 10,
    fill: "#434343"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8333 13.9997H17.7C16.5799 13.9997 16.0198 13.9997 15.592 14.2177C15.2157 14.4094 14.9097 14.7154 14.718 15.0917C14.5 15.5195 14.5 16.0796 14.5 17.1997V22.7997C14.5 23.9198 14.5 24.4798 14.718 24.9077C14.9097 25.284 15.2157 25.5899 15.592 25.7817C16.0198 25.9997 16.5799 25.9997 17.7 25.9997H23.8333C24.4533 25.9997 24.7633 25.9997 25.0176 25.9315C25.7078 25.7466 26.2469 25.2075 26.4319 24.5173C26.5 24.263 26.5 23.953 26.5 23.333M25.1667 17.333V13.333M23.1667 15.333H27.1667M19.5 17.6663C19.5 18.4027 18.903 18.9997 18.1667 18.9997C17.4303 18.9997 16.8333 18.4027 16.8333 17.6663C16.8333 16.93 17.4303 16.333 18.1667 16.333C18.903 16.333 19.5 16.93 19.5 17.6663ZM22.4934 19.9451L16.8541 25.0717C16.5369 25.3601 16.3783 25.5042 16.3643 25.6291C16.3521 25.7374 16.3936 25.8448 16.4755 25.9167C16.5699 25.9997 16.7842 25.9997 17.2129 25.9997H23.4707C24.4301 25.9997 24.9098 25.9997 25.2866 25.8385C25.7596 25.6361 26.1365 25.2593 26.3388 24.7863C26.5 24.4095 26.5 23.9298 26.5 22.9703C26.5 22.6475 26.5 22.4861 26.4647 22.3358C26.4204 22.1469 26.3353 21.9699 26.2155 21.8173C26.1202 21.6958 25.9941 21.595 25.742 21.3933L23.8772 19.9014C23.6249 19.6996 23.4988 19.5987 23.3599 19.5631C23.2374 19.5317 23.1086 19.5358 22.9884 19.5748C22.852 19.6191 22.7324 19.7278 22.4934 19.9451Z",
    stroke: "#2EC99E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/upload-image.3e8899615ce15630ee0b9938770ad8a9.svg";
export { ForwardRef as ReactComponent };